export const MAP_STYLE = `${process.env.GATSBY_MAP_STYLE}`;
export const MAPBOX_TOKEN = `${process.env.GATSBY_MAPBOX_TOKEN}`;
